<template>
  <div class="flex-1 overflow-auto p-4 flex justify-between flex-col">
    <!-- List Audit Logs -->
    <div>
      <div>
        <p
          v-if="!uiFlags.fetchingList && !records.length"
          class="flex h-full items-center flex-col justify-center"
        >
          {{ $t('AUDIT_LOGS.LIST.404') }}
        </p>
        <woot-loading-state
          v-if="uiFlags.fetchingList"
          :message="$t('AUDIT_LOGS.LOADING')"
        />

        <div
          v-if="!uiFlags.fetchingList && records.length"
          class="space-y-4"
        >
          <article
            v-for="auditLogItem in records"
            :key="auditLogItem.id"
            class="rounded-lg border border-slate-200 bg-white p-4 shadow-sm transition dark:border-slate-700 dark:bg-slate-900/60"
          >
            <header class="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
              <div>
                <p class="text-sm font-medium text-slate-900 dark:text-slate-100">
                  {{ recordHeadline(auditLogItem) }}
                </p>
                <p class="text-xs text-slate-500 dark:text-slate-400">
                  {{ recordMetadata(auditLogItem) }}
                </p>
              </div>
              <time
                class="text-xs uppercase tracking-wide text-slate-500 dark:text-slate-400"
              >
                {{
                  messageTimestamp(
                    auditLogItem.created_at,
                    'MMM dd, yyyy hh:mm a'
                  )
                }}
              </time>
            </header>
            <audit-log-details :audit-log-item="auditLogItem" />
          </article>
        </div>
      </div>
    </div>
    <table-footer
      :current-page="Number(meta.currentPage)"
      :total-count="meta.totalEntries"
      :page-size="meta.perPage"
      class="dark:bg-slate-900"
      @page-change="onPageChange"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import TableFooter from 'dashboard/components/widgets/TableFooter';
import timeMixin from 'dashboard/mixins/time';
import alertMixin from 'shared/mixins/alertMixin';
import {
  generateTranslationPayload,
  generateLogActionKey,
} from 'dashboard/helper/auditlogHelper';
import AuditLogDetails from './components/AuditLogDetails.vue';

export default {
  components: {
    TableFooter,
    AuditLogDetails,
  },
  mixins: [alertMixin, timeMixin],
  data() {
    return {
      loading: {},
      auditLogsAPI: {
        message: '',
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    // Fetch Audit Logs on page load without manual refresh
    next(vm => {
      vm.fetchAuditLogs();
    });
  },
  computed: {
    ...mapGetters({
      records: 'auditlogs/getAuditLogs',
      uiFlags: 'auditlogs/getUIFlags',
      meta: 'auditlogs/getMeta',
      agentList: 'agents/getAgents',
    }),
  },
  mounted() {
    // Fetch API Call
    this.$store.dispatch('agents/get');
  },
  methods: {
    fetchAuditLogs() {
      const page = this.$route.query.page ?? 1;
      this.$store.dispatch('auditlogs/fetch', { page }).catch(error => {
        const errorMessage =
          error?.message || this.$t('AUDIT_LOGS.API.ERROR_MESSAGE');
        this.showAlert(errorMessage);
      });
    },
    generateLogText(auditLogItem) {
      const translationPayload = generateTranslationPayload(
        auditLogItem,
        this.agentList
      );
      const translationKey = generateLogActionKey(auditLogItem);

      return this.$t(translationKey, translationPayload);
    },
    recordHeadline(auditLogItem) {
      const text = this.generateLogText(auditLogItem);
      if (text) {
        return text;
      }

      return this.$t('AUDIT_LOGS.LIST.FALLBACK', {
        user: this.$t('AUDIT_LOGS.DEFAULT_USER'),
        action: auditLogItem.action,
      });
    },
    recordMetadata(auditLogItem) {
      return this.$t('AUDIT_LOGS.LIST.METADATA', {
        type: auditLogItem.auditable_type || this.$t('AUDIT_LOGS.LIST.UNKNOWN'),
        id: auditLogItem.auditable_id ?? this.$t('AUDIT_LOGS.LIST.UNKNOWN'),
        ip: auditLogItem.remote_address || this.$t('AUDIT_LOGS.LIST.UNKNOWN'),
      });
    },
    onPageChange(page) {
      window.history.pushState({}, null, `${this.$route.path}?page=${page}`);
      try {
        this.$store.dispatch('auditlogs/fetch', { page });
      } catch (error) {
        const errorMessage =
          error?.message || this.$t('AUDIT_LOGS.API.ERROR_MESSAGE');
        this.showAlert(errorMessage);
      }
    },
  },
};
</script>
